import React from 'react'
import clsx from 'clsx'

interface PanelSurfaceProps {
  children: React.ReactNode
  className?: string
}

const PanelSurface: React.FC<PanelSurfaceProps> = ({ children, className }) => {
  return (
    <div
      className={clsx(
        'bg-[var(--panel-bg)] border border-[var(--panel-border)] rounded-lg',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default PanelSurface
